import { AngularFireAuth } from 'angularfire2/auth';
import { Component } from '@angular/core';
import { NavController, AlertController, Loading } from 'ionic-angular';
import * as firebase from 'firebase';

import { HomePage } from '../home/home';
import { TermsofusePage } from '../termsofuse/termsofuse';
import { PrivacypolicyPage } from '../privacypolicy/privacypolicy';
import { CookiesPage } from '../cookies/cookies';
import { LegalPage } from '../legal/legal';
import { TranslateService } from '@ngx-translate/core';
import { AppUtilities } from '../../app/app.utilities';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var window;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  public facebookProvider = new firebase.auth.FacebookAuthProvider();
  public googleProvider = new firebase.auth.GoogleAuthProvider();
  public termsofusePage = TermsofusePage;
  public privacyPolicy = PrivacypolicyPage;
  public cookies = CookiesPage;
  public legalPage = LegalPage;

  terminosUso: boolean;

  constructor(
    public afAuth: AngularFireAuth,
    public nav: NavController,
    public alertCtrl: AlertController,
    private _translate: TranslateService,
    private utils: AppUtilities
  ) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  loginWith(provider: firebase.auth.AuthProvider) {
    if (this.terminosUso) {
      this.afAuth.auth.signInWithRedirect(provider).then(() => {
        this.afAuth.auth.getRedirectResult().then(result => {
          console.log('Result ', result);
          //this.nav.setRoot(HomePage);
        });
      });
    } else {
      var WARNING_TEXT_LOGIN = this._translate.instant('WARNING_TEXT_LOGIN');
      const alert = this.alertCtrl.create({
        subTitle: WARNING_TEXT_LOGIN,
        buttons: ['OK']
      });
      alert.present();
    }
  }

  updateValue() {
    console.log('Check box ' + this.terminosUso);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts